import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { PublisherRepresentativeListStore } from "../../store/PublisherRepresentativeListStore";

type PublisherRepresentativeListDialogsProps = {
  store: PublisherRepresentativeListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de PublisherRepresentative.
 * Separado para mantener PublisherRepresentativeListPage más limpio.
 */
export const PublisherRepresentativeListDialogs: React.FC<PublisherRepresentativeListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
